import { render, staticRenderFns } from "./photo-preview.vue?vue&type=template&id=406170c8&scoped=true"
import script from "./photo-preview.vue?vue&type=script&lang=js"
export * from "./photo-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406170c8",
  null
  
)

export default component.exports